<!-- Top Navigation Bar -->
<nav class="top-navbar navbar navbar-expand navbar-dark bg-dark px-3" *ngIf="user">
    <div class="d-flex align-items-center">
        <button class="sidebar-toggle btn btn-link text-white p-2 me-2" (click)="toggleSidebar()">
            <i class="bi bi-list" style="font-size: 20px;"></i>
        </button>
        <div class="navbar-brand d-flex align-items-center" routerLink="/" style="cursor: pointer;">
            <img src="assets/FlytaErpLogo-removebg-preview.png" alt="FlytaERP Logo" style="height: 32px; margin-right: 8px;">
            FlytaERP
        </div>
    </div>
    
    <div class="ms-auto position-relative">
        <div class="user-avatar-container" (click)="toggleDropdown()">
            <div class="user-avatar">
                {{ getUserInitials() }}
            </div>
            <i class="bi bi-chevron-down dropdown-arrow" [class.rotated]="showDropdown"></i>
        </div>
        
        <div class="dropdown-menu custom-dropdown" [class.show]="showDropdown">
            <div class="dropdown-header">
                <div class="user-info">
                    <div class="user-name">{{ user!.firstName }} {{ user!.lastName }}</div>
                    <div class="user-email">{{ user!.username }}</div>
                    <div class="user-context" *ngIf="companyName || user!.roleName">
                        <span class="company-detail" *ngIf="companyName"><i class="bi bi-building"></i>{{ companyName }}</span>
                        <span class="role-badge" *ngIf="user!.roleName"><i class="bi bi-person-badge"></i>{{ user!.roleName }}</span>
                    </div>
                </div>
            </div>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/account/change-password" (click)="showDropdown = false">
                <i class="bi bi-person-gear me-2"></i>
                Account Settings
            </a>
            <button class="dropdown-item logout-item" (click)="logout()">
                <i class="bi bi-box-arrow-right me-2"></i>
                Logout
            </button>
        </div>
    </div>
</nav>

<!-- Sidebar Navigation -->
<div class="sidebar" [class.collapsed]="sidebarCollapsed" [class.mobile]="isMobile" *ngIf="user">
    <div class="sidebar-content">
        <a class="sidebar-item" routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" 
           *ngIf="!accountService.isSales()"
           (click)="isMobile && toggleSidebar()" 
           data-tooltip="Home">
            <i class="bi bi-house-door"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Home</span>
        </a>
       
        <!-- Transporter-only menu -->
        <a class="sidebar-item" routerLink="/transporter" routerLinkActive="active" 
           *ngIf="accountService.isTransporter()" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Lorry Receipts">
            <i class="bi bi-truck"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Lorry Receipts</span>
        </a>
        
        <!-- Regular ERP menus (hidden for transporter users) -->
        <a class="sidebar-item" routerLink="/sales" routerLinkActive="active" 
           *ngIf="!accountService.isTransporter() && accountService.hasPermission('sales', 'canRead')" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Sales">
            <i class="bi bi-cart-check"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Sales</span>
        </a>
        <a class="sidebar-item" routerLink="/customers" routerLinkActive="active" 
           *ngIf="accountService.hasPermission('customers', 'canRead') || accountService.isTransporter()" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Customers">
            <i class="bi bi-people"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Contacts</span>
        </a>
        
        <!-- Purchase Menu with Submenu (hidden for transporter users) -->
        <div class="sidebar-menu-group" routerLinkActive="" #purchaseRoutes="routerLinkActive" (isActiveChange)="purchaseMenuExpanded = $event" *ngIf="!accountService.isTransporter() && (accountService.isAdmin() || accountService.hasPermission('expenses', 'canRead') || accountService.hasPermission('products', 'canRead') || accountService.hasPermission('purchase', 'canRead') || accountService.hasPermission('purchase-return', 'canRead') || accountService.hasPermission('supplier-credit-notes', 'canRead') || accountService.hasPermission('sales', 'canRead') || accountService.hasPermission('ledger', 'canRead'))">
            <a class="sidebar-item sidebar-parent" 
               (click)="togglePurchaseMenu()"
               [class.active]="purchaseRoutes.isActive"
               [class.expanded]="purchaseMenuExpanded"
               data-tooltip="Purchase">
                <i class="bi bi-cart"></i>
                <span [class.hide-text]="sidebarCollapsed && !isMobile">Purchase</span>
                <i class="bi bi-chevron-down submenu-arrow" [class.expanded]="purchaseMenuExpanded"></i>
            </a>
            
            <div class="submenu" [class.expanded]="purchaseMenuExpanded">
                <a class="sidebar-item submenu-item" 
                   routerLink="/products" 
                   routerLinkActive="active"
                   *ngIf="accountService.hasPermission('products', 'canRead')"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="Products">
                    <i class="bi bi-box-seam"></i>
                    <span>Products</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/purchase" 
                   routerLinkActive="active"
                         [routerLinkActiveOptions]="{ exact: true }"
                           *ngIf="accountService.hasPermission('expenses', 'canRead') || accountService.hasPermission('purchase', 'canRead')"
                   (click)="isMobile ? toggleSidebar() : null"
                   data-tooltip="Purchase Invoices">
                    <i class="bi bi-file-earmark-check"></i>
                    <span>Invoices</span>
                </a>
                     <a class="sidebar-item submenu-item"
                         routerLink="/purchase/brand-offers"
                         routerLinkActive="active"
                         (click)="isMobile && toggleSidebar()"
                         data-tooltip="Running Brand Offers">
                          <i class="bi bi-percent"></i>
                          <span>Brand Offers</span>
                     </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/purchase-return" 
                   routerLinkActive="active"
                         *ngIf="accountService.hasPermission('purchase-return', 'canRead')"
                   (click)="isMobile ? toggleSidebar() : null"
                   data-tooltip="Purchase Returns">
                    <i class="bi bi-box-arrow-in-left"></i>
                    <span>Purchase Returns</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/supplier-credit-notes" 
                   routerLinkActive="active"
                         *ngIf="accountService.hasPermission('supplier-credit-notes', 'canRead')"
                   (click)="isMobile ? toggleSidebar() : null"
                   data-tooltip="Supplier Credit Notes">
                    <i class="bi bi-file-earmark-text"></i>
                    <span>Supplier Credit Notes</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/sales/customer-credit-notes" 
                   routerLinkActive="active"
                   *ngIf="accountService.hasPermission('sales', 'canRead')"
                   (click)="isMobile ? toggleSidebar() : null"
                   data-tooltip="Customer Credit Notes">
                    <i class="bi bi-credit-card"></i>
                    <span>Customer Credit Notes</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/ledger" 
                   routerLinkActive="active"
                         *ngIf="accountService.hasPermission('ledger', 'canRead')"
                   (click)="isMobile ? toggleSidebar() : null"
                   data-tooltip="Ledger">
                    <i class="bi bi-journal-text"></i>
                    <span>Ledger</span>
                </a>
            </div>
        </div>
        
        <a class="sidebar-item" routerLink="/expenses" routerLinkActive="active" 
           *ngIf="!accountService.isTransporter() && accountService.hasPermission('expenses', 'canRead')" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Transactions">
            <i class="bi bi-receipt"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Transactions</span>
        </a>
        <a class="sidebar-item" routerLink="/wholesale" routerLinkActive="active" 
           *ngIf="!accountService.isTransporter() && accountService.hasPermission('wholesale', 'canRead')" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Wholesale">
            <i class="bi bi-shop"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Wholesale</span>
        </a>
        <a class="sidebar-item" routerLink="/reports" routerLinkActive="active" 
              *ngIf="!accountService.isTransporter() && accountService.hasPermission('reports', 'canRead')" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Reports">
            <i class="bi bi-graph-up"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Reports</span>
        </a>
        <!-- Payroll Menu with Submenu: Attendance, Salary Structure, My Salary (hidden for transporter users) -->
        <div class="sidebar-menu-group" routerLinkActive="" #payrollRoutes="routerLinkActive" (isActiveChange)="payrollMenuExpanded = $event" *ngIf="!accountService.isTransporter() && (accountService.isAdmin() || accountService.hasPermission('attendance', 'canRead') || accountService.hasPermission('payroll', 'canRead') || accountService.userValue?.employeeId)">
            <a class="sidebar-item sidebar-parent" 
               (click)="togglePayrollMenu()"
               [class.active]="payrollRoutes.isActive"
               [class.expanded]="payrollMenuExpanded"
               data-tooltip="Payroll">
                <i class="bi bi-cash-stack"></i>
                <span [class.hide-text]="sidebarCollapsed && !isMobile">Payroll</span>
                <i class="bi bi-chevron-down submenu-arrow" [class.expanded]="payrollMenuExpanded"></i>
            </a>

            <div class="submenu" [class.expanded]="payrollMenuExpanded">
                <a class="sidebar-item submenu-item" 
                   routerLink="/attendance" 
                   routerLinkActive="active"
                   *ngIf="accountService.isAdmin() || accountService.hasPermission('attendance', 'canRead')"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="Attendance">
                    <i class="bi bi-calendar-check"></i>
                    <span>Attendance</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/payroll" 
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{exact:true}"
                   *ngIf="accountService.isAdmin() || accountService.hasPermission('payroll', 'canRead')"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="Salary Structure">
                    <i class="bi bi-cash-coin"></i>
                    <span>Salary Structure</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/payroll/my" 
                   routerLinkActive="active"
                   *ngIf="accountService.userValue?.employeeId"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="My Salary">
                    <i class="bi bi-wallet2"></i>
                    <span>My Salary</span>
                </a>
            </div>
        </div>
        <a class="sidebar-item" routerLink="/masters" routerLinkActive="active" 
              *ngIf="accountService.hasPermission('masters', 'canRead') || accountService.isTransporter()" 
           (click)="isMobile && toggleSidebar()"
           data-tooltip="Masters">
            <i class="bi bi-gear"></i>
            <span [class.hide-text]="sidebarCollapsed && !isMobile">Masters</span>
        </a>
        
        <!-- Admin Menu with Submenu (hidden for transporter and company admin users) -->
        <div class="sidebar-menu-group" routerLinkActive="" #adminRoutes="routerLinkActive" (isActiveChange)="adminMenuExpanded = $event" *ngIf="!accountService.isTransporter() && !accountService.isCompanyAdmin() && (accountService.hasPermission('users', 'canRead') || accountService.isSuperAdmin())">
            <a class="sidebar-item sidebar-parent" 
               (click)="toggleAdminMenu()"
               [class.active]="adminRoutes.isActive"
               [class.expanded]="adminMenuExpanded"
               data-tooltip="Admin">
                <i class="bi bi-shield-lock"></i>
                <span [class.hide-text]="sidebarCollapsed && !isMobile">Admin</span>
                <i class="bi bi-chevron-down submenu-arrow" [class.expanded]="adminMenuExpanded"></i>
            </a>
            
            <div class="submenu" [class.expanded]="adminMenuExpanded">
                <a class="sidebar-item submenu-item" 
                   routerLink="/users" 
                   routerLinkActive="active"
                   *ngIf="accountService.hasPermission('users', 'canRead')"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="Role Management">
                    <i class="bi bi-shield-check"></i>
                    <span>Role Management</span>
                </a>
                <a class="sidebar-item submenu-item" 
                   routerLink="/admin" 
                   routerLinkActive="active"
                   *ngIf="accountService.isSuperAdmin()"
                   (click)="isMobile && toggleSidebar()"
                   data-tooltip="SuperAdmin">
                    <i class="bi bi-shield-fill"></i>
                    <span>SuperAdmin</span>
                </a>
            </div>
        </div>
    </div>
</div>

<!-- Main Content Area -->
<div class="main-content" [class.with-sidebar]="user && !sidebarCollapsed" [class.sidebar-collapsed]="user && sidebarCollapsed && !isMobile">
    <alert></alert>
    <router-outlet></router-outlet>
</div>